module.exports = __webpack_public_path__ + "static/spaceman-7802982459bc042cbd7d371e2c3e0323.png";